'use strict';

module.exports = {
    SIGN: 'ВОЙДИТЕ',
    SIGN_JOIN: 'Войдите или зарегистрируйтесь!',
    EMAIL_EXISTS: 'Этот e-mail уже существует.',
    INVALID_EMAIL: 'Пожалуйста, укажите Ваш адрес электронной почты',
    INVALID_FIRST_NAME: 'Пожалуйста, укажите Ваше имя',
    INVALID_LAST_NAME: 'Пожалуйста, укажите Вашу фамилию',
    INVALID_PASSWORD: 'Пожалуйста, используйте 6-20 символов (только A-Z, a-z, 0-9)',
    INVALID_REPASSWORD: 'Пароли не совпадают',
    INVALID_VALID_CODE: 'Пожалуйста, введите действительный код',
    UNAVIALABLE_SERVICE: 'Служба недоступна, повторите попытку позже.',
    EMPTY_VALID_CODE: 'Введите символы, которые изображены на картинке',
    NOT_MEMBER: 'Не зарегистрированы?',
    ALREADY_MEMBER: 'Уже зарегистрированы на AliExpress/Alibaba?',
    EMAIL: 'Email',
    CONTACT_NAME: 'Контактное лицо:',
    FIRST_NAME: 'Имя',
    LAST_NAME: 'Фамилия',
    PASSWORD: 'Пароль',
    REPASSWORD: 'Повторите пароль:',
    EMPTY_CODE: 'Введите указанный код:',
    REFRESH: 'Обновить',
    CREATE_MY_ACCOUNT: 'Создать мою учетную запись',
    NAME: 'Как вас зовут',
    VERIFICATION: 'Код проверки',
    AGREE_MENT: 'Если вы создаёте учётную запись, вы автоматически соглашаетесь с С',
    AE_MEMBER_SHIP: 'Соглашение о бесплатном членстве на AliExpress.com',
    AND: 'и',
    PRIVACY_POLICY: 'Политикой конфиденциальности',
    SLIDE_SUBMIT: 'Слайд вправо для проверки',
    SLIDE_SUBMIT_TIPS: 'Готово',
    LOADING: 'Загрузка…',
    SLIDE_SUBMIT_ERROR_TIPS: 'Слайд вправо для проверки',
    SHOP_NOW: 'Купить сейчас',
    SIGN_IN: 'Войти',
    REGISTER_SMS: 'Зарегистрироваться по SMS',
    REGISTER_EMAIL: 'Зарегистрироваться по Email',
    PHONE_NUMBER: 'Номер телефона',
    VALID_NUMBER: 'Укажите номер телефона',
    SEND_SMS_CODE: 'Отправить SMS с кодом',
    SMS_POLICY: 'Мы отправим код подтверждения SMS-сообщением на номер телефон, который вы указали. Убедитесь, что правильно указали номер и код страны.',
    SEND_TO: 'Мы отправили код на номер',
    VERIFICATION_RECEIVED: 'Введите полученный код или',
    EDIT_NUMBER: 'измените номер телефона.',
    RESEND_CODE: 'Отправить ещё раз',
    LAST_STEP: 'Последний шаг',
    SET_SIGN_IN_PASSWORD: 'Создайте пароль, чтобы гарантировать безопасность своего аккаунта.',
    INVALID_PHONE_PASSWORD: '6-20 знаков (буквы или цифры)',
    NOT_CORRECT_CODE: 'Неверный код. Попробуйте ещё раз.',
    SAVE_PASSWORD: 'Сохранить пароль',
    NO_RECEIVED_CODE: 'Если вы не получили сообщение, попробуйте',
    VIA_EMAIL: 'зарегистрироваться с помощью email.'
};